import GameFactIcon_Dsas from "../../../dsasComponents/GameFactIcon_Dsas"
import gameFacts from "../gameFact/gamefacts.js"

import {
    GAME_FACT_SOCCER_BUT,
    GAME_FACT_SOCCER_YELLOWCARD,
    GAME_FACT_SOCCER_PENALTY,
    GAME_FACT_SOCCER_SHOT,
    GAME_FACT_SOCCER_REDCARD, 
    GAME_FACT_SOCCER_SHOOTOUTPENALTY,
    GAME_FACT_SOCCER_STAR,

    //RUGBY
    GAME_FACT_REDCARD, 
    GAME_FACT_SHOOTOUTPENALTY, 
    GAME_FACT_ESSAI, 
    GAME_FACT_PENALITE, 
    GAME_FACT_TRANSFORMATION, 
    GAME_FACT_DROP,
    GAME_FACT_RUGBY_STAR,

    GAME_FACT_BASKET_FREETHROW,
    GAME_FACT_BASKET_TWOPOINTS,
    GAME_FACT_BASKET_THREEPOINTS,
    GAME_FACT_BASKET_FAULT,
    GAME_FACT_BASKET_TECHNICAL,
    GAME_FACT_BASKET_TIMEOUT,

    GAME_FACT_HANDBALL_GOAL,
    GAME_FACT_HANDBALL_REDCARD,
    GAME_FACT_HANDBALL_PENALTY,
    GAME_FACT_HANDBALL_TIMEOUT,
    GAME_FACT_HANDBALL_TURNOVER,
    GAME_FACT_HANDBALL_TWOMIN_SUSPENSION,
    GAME_FACT_HANDBALL_SHOOTOUT,
    GAME_FACT_HANDBALL_YELLOWCARD
    
} from '../gameFact/constants'
import { useDispatch } from "react-redux"
import { createGameFact } from "../../../actions/gameFact"
import { getGameFactDetail, getSoccerButDetail } from "./utils"
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from "@mui/material"
import { useCallback, useEffect, useMemo, useState } from "react"

import Select_Dsas from "../../../dsasComponents/Select_Dsas.js"
import { getPlayerList } from "../utils/feuilleMatch.js"

import btn_soccer_shoutout_fail from '../../../images/game-fact/buttons/soccer/btn_tir_au_but_rate_foot.png'
import btn_soccer_shoutout_succed from '../../../images/game-fact/buttons/soccer/btn_tir_au_but_reussi_foot.png'

import btn_soccer_shot_succed from '../../../images/game-fact/buttons/soccer/btn_tir_cadre_foot.png'
import btn_soccer_penalty_succed from '../../../images/game-fact/buttons/soccer/btn_penalty_reussi_foot.png'

import btn_rugby_shoutout_fail from '../../../images/game-fact/buttons/rugby/btn_tir_au_but_rate_rugby.png'
import btn_rugby_shoutout_succed from '../../../images/game-fact/buttons/rugby/btn_tir_au_but_reussi_rugby.png'

import btn_tir_au_but_rate_hand from '../../../images/game-fact/buttons/handball/btn_tir_au_but_rate_hand.png'
import btn_tir_au_but_reussi_hand from '../../../images/game-fact/buttons/handball/btn_tir_au_but_reussi_hand.png'

import btn_penalty_rate_hand from '../../../images/game-fact/buttons/handball/btn_penalty_rate_hand.png'
import btn_penalty_reussi_hand from '../../../images/game-fact/buttons/handball/btn_penalty_reussi_hand.png'

import btn_but_hand from '../../../images/game-fact/buttons/handball/btn_but_hand.png'
import btn_but_refuse_hand from '../../../images/game-fact/buttons/handball/btn_but_refuse_hand.png'
import PeriodTimerSelector from "./PeriodTimerSelector.js"

 


const LiveSaisieRapide = ({match, surchargePeriod}) => {

    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch()

    const [playerSelected, setPlayerSelected] = useState([{_id : 0}, {_id : 0}])

    const [currentPeriod, setCurrentPeriod] = useState();
    const [currentTimer, setCurrentTimer] = useState();

    const [timerRecapData, setTimerRecapData] = useState()

    const playersList = useMemo(() => {
        return [match.homeTeam, match.awayTeam].map(team => getPlayerList(match, team._id))
    }, [])

    useEffect(() => {
        setCurrentPeriod(match.period);
        setCurrentTimer(match.timer);
    }, []);

    const updateRecapData = (payload = { period : 0, timer : 0}) => {
        setTimerRecapData(payload)
    }

    const handlePeriodChange = (newPeriod) => {
        setCurrentPeriod(newPeriod);
        // Logique supplémentaire pour gérer les changements de période
    };

    const handleTimerChange = (newTimer) => {
        setCurrentTimer(newTimer);
        // Logique supplémentaire pour gérer les changements de timer
    };

    const gameFactsToUse = useMemo(() => {
        return gameFacts.filter(g => g.discipline === match.discipline && g.pos && g.show && g.show.includes(surchargePeriod) &&
        (g.id===GAME_FACT_SOCCER_BUT 
            || g.id===GAME_FACT_SOCCER_REDCARD
            || g.id===GAME_FACT_SOCCER_SHOOTOUTPENALTY
            || g.id===GAME_FACT_SOCCER_STAR
            || g.id===GAME_FACT_SOCCER_SHOT
            || g.id===GAME_FACT_SOCCER_PENALTY
            || g.id===GAME_FACT_SOCCER_YELLOWCARD

            || g.id===GAME_FACT_PENALITE
            || g.id===GAME_FACT_TRANSFORMATION
            || g.id===GAME_FACT_DROP
            || g.id===GAME_FACT_ESSAI
            || g.id===GAME_FACT_REDCARD
            || g.id===GAME_FACT_SHOOTOUTPENALTY
            || g.id===GAME_FACT_RUGBY_STAR


            || g.id===GAME_FACT_BASKET_FREETHROW
            || g.id===GAME_FACT_BASKET_TWOPOINTS
            || g.id===GAME_FACT_BASKET_THREEPOINTS
            || g.id===GAME_FACT_BASKET_FAULT
            || g.id===GAME_FACT_BASKET_TECHNICAL
            || g.id===GAME_FACT_BASKET_TIMEOUT

            || g.id===GAME_FACT_HANDBALL_GOAL
            || g.id===GAME_FACT_HANDBALL_SHOOTOUT
            || g.id===GAME_FACT_HANDBALL_TWOMIN_SUSPENSION
            || g.id===GAME_FACT_HANDBALL_YELLOWCARD
            || g.id===GAME_FACT_HANDBALL_REDCARD
            || g.id===GAME_FACT_HANDBALL_PENALTY
            || g.id===GAME_FACT_HANDBALL_TIMEOUT
            || g.id===GAME_FACT_HANDBALL_TURNOVER
            
            ))
    }, [surchargePeriod])

    const col = useMemo(() => {

        const result = gameFactsToUse.reduce((acc,curr) => {

            const {pos, id} = curr

            if([GAME_FACT_SHOOTOUTPENALTY, 

                GAME_FACT_SOCCER_SHOOTOUTPENALTY, 
                GAME_FACT_SOCCER_SHOT,
                GAME_FACT_SOCCER_PENALTY,

                GAME_FACT_HANDBALL_PENALTY, 
                GAME_FACT_HANDBALL_SHOOTOUT,
                GAME_FACT_HANDBALL_GOAL].includes(id)){
                let imgSucced = curr.img
                let imgFail = curr.img
                if(id === GAME_FACT_SHOOTOUTPENALTY){
                    imgSucced = btn_rugby_shoutout_succed
                    imgFail = btn_rugby_shoutout_fail
                }

                if(id === GAME_FACT_SOCCER_SHOOTOUTPENALTY){
                    imgSucced = btn_soccer_shoutout_succed
                    imgFail = btn_soccer_shoutout_fail
                }
                
                if(id === GAME_FACT_SOCCER_SHOT){
                    imgSucced = btn_soccer_shot_succed
                    imgFail = undefined
                }

                if(id === GAME_FACT_SOCCER_PENALTY){
                    imgSucced = btn_soccer_penalty_succed
                    imgFail = undefined
                }

                if(id === GAME_FACT_HANDBALL_PENALTY){
                    imgSucced = btn_penalty_reussi_hand
                    imgFail = btn_penalty_rate_hand
                }
                if(id === GAME_FACT_HANDBALL_SHOOTOUT){
                    imgSucced = btn_tir_au_but_reussi_hand
                    imgFail = btn_tir_au_but_rate_hand
                }

                if(id === GAME_FACT_HANDBALL_GOAL){
                    imgSucced = btn_but_hand
                    imgFail = btn_but_refuse_hand
                }


                if(imgFail){
                    acc.push({...curr, subId : curr.id+'_FAIL', img : imgFail, pos})
                }

                if(imgSucced){
                    acc.push({...curr, subId : curr.id, img : imgSucced, pos})
                }
            }else{
                    acc.push(curr)
            }
    
            return acc
    
        }, [])

        //pos = pos:[x,y] --> x colonne (0 ou 1) - y ligne (0 à infini) /ex: (0,2 --> item 1ere colonne, ligne 3);
        result.sort((a, b) => (a.pos[0] + a.pos[1]) - (b.pos[0] + b.pos[1]) + (b.pos[0] - a.pos[0]) )

        return result
    }, [gameFactsToUse])

    const selectPlayer = (playerId, team, idxTeam) => {

        const player = team.players.find(p => p._id === playerId)

        let newPlayerSelected = [...playerSelected];
        if(player){
            newPlayerSelected[idxTeam] = player
        }else{
            newPlayerSelected[idxTeam] = {_id : 0}
        }
        setPlayerSelected(newPlayerSelected)
    }

    const saveGameFact = (gameFact, team, player) => {
        const getDetails = getGameFactDetail(gameFact)
    
        if(getDetails){
            let defaultDetail = {}
            if(match.timer !== currentTimer){
                defaultDetail.timer = currentTimer
            }

            if(match.period !== currentPeriod){
                defaultDetail.period = currentPeriod
            }

            dispatch(createGameFact(getDetails(match, team, player, defaultDetail), gameFact.id, match))
        }     
    }

    return (
    <Box>
        <PeriodTimerSelector
            match={match}
            onPeriodChange={handlePeriodChange}
            onTimerChange={handleTimerChange}
            updateRecapData={updateRecapData}
        />
        <Grid container direction={isSmall ? "column" : "row"} display={'flex'} >

        {[match.homeTeam, match.awayTeam].map((team, idx) => (
        <Box sx={{width : isSmall ? '100%' : '50%' , padding : '20px'}}>
        <Typography variant="caption" fontSize="1.4em" component={'div'} sx={{width : '100%', color : team.textColor, bgcolor : team.color}}>{team.name}</Typography>
        <Select_Dsas 
        items={[{_id : 0, name : 'Equipe'}, ...playersList[idx]]} 
        onChange={(e) => selectPlayer(e.target.value, team, idx)} 
        value={playerSelected[idx]._id}
        onReset={() => selectPlayer(0, team, idx)}/>

{
    timerRecapData && <Box  m={'1rem'}
                            mb={0}
                            textAlign={'left'} 
                            paddingLeft='1rem!important' 
                            fontSize={'1.1em'} 
                            color={'white'} 
                            backgroundColor={'#2e7d32'} 
                            borderRadius={'20px'}
                            p='0.7rem!important'
                            >
                            <Box><Typography variant="body1" component='span'>Période de saisie :</Typography><Typography variant="caption" fontSize={'1rem'} fontWeight={'bold'} component='span'> {timerRecapData.period}</Typography></Box>
                            <Box><Typography variant="body1" component='span'>Chrono de saisie :</Typography><Typography variant="caption" fontSize={'1rem'} fontWeight={'bold'} component='span'> {timerRecapData.timer}</Typography></Box>
                        </Box>
}

            <Grid container sx={{display : 'flex', flexDirection : 'row', justifyContent : "flex-start"}}>
                <Grid item xs={12} sx={{paddingTop : 1}}>
                        {col.map(g => <GameFactIcon_Dsas src={g.img} onClick={() => saveGameFact(g, team, playerSelected[idx])}/>)}
                </Grid>
            </Grid>
            
        </Box>
        ))}
        </Grid>
    </Box>
    )
}

export default LiveSaisieRapide